import { AlpineComponent } from "alpinejs";
import {
  default as AjaxList,
  ListXDataContext as AjaxListXDataContext,
  ListOptions as AjaxListOptions
} from '../../../components/AjaxList/Classes/List';
import ListItem from "../../../components/AjaxList/Classes/Item";
import { IHistoryStateProps } from "../../../utils/historyState";

export type ListComponent = AlpineComponent<AjaxListXDataContext<ListItem> & {
  cartCount: number;
  orderItem: (event: Event) => void;
  orderItems: Array<{ id: string; name: string; count: number }>;
  resetFilter: () => void;
  stickyHeader: () => void;
  toggleFilterClass: (event: Event) => void;
  toggleCart: () => void;
  updateCartCount: (itemId: string, newCount: number) => void;
}>;

export type ListOptions = AjaxListOptions & IHistoryStateProps;

const List = (options: ListOptions, filterData = {}):ListComponent => {
  return {
    ...AjaxList(options, filterData),
    cartCount: 0,
    items: [],
    orderItems: [],

    created() {
      addEventListener("scroll", () => {
        this.stickyHeader();
      });
    },

    resetFilter() {
      this.filter!.data = {};
    },

    stickyHeader() {
      const wrapper = document.querySelector('.wrapper--fixable') as HTMLElement;
      if (wrapper) {
        const offset = wrapper.dataset.y || 0;
        if (offset) {
          if (window.scrollY >= parseInt(offset)) {
            wrapper.classList.add('wrapper--fixed');
          } else {
            wrapper.classList.remove('wrapper--fixed');
          }
        }
      }
    },

    orderItem(event: Event) {
      const eTarget = event.currentTarget as HTMLElement;
      if (eTarget) {
        const itemId = eTarget.dataset.itemid;
        const itemName = eTarget.dataset.itemname;
        const countInput = document.getElementById('order-item-' + itemId) as HTMLInputElement;
        const count = Number(countInput.value);

        if (count > 0) {
          const existingItemIndex = this.orderItems.findIndex(item => item.id === itemId);

          if (existingItemIndex !== -1) {
            // Item exists, update the count
            this.orderItems[existingItemIndex].count += count;
          } else {
            // Item does not exist, add new item
            if (itemId && itemName) {
              let newItem = { id: itemId, name: itemName, count: count };
              this.orderItems.push(newItem);
            }
          }

          this.cartCount += count; // Update cartCount
          countInput.value = '0'; // Remove count from input
          const submitButton = document.querySelector('#form-order .order-submit') as HTMLButtonElement;
          if (submitButton) {
            submitButton.disabled = false;
          }
        }
      }
    },

    updateCartCount(itemId: string, newCount: number) {
      const itemIndex = this.orderItems.findIndex(item => item.id === itemId);
      if (itemIndex !== -1) {
        newCount = Number(newCount);
        const oldCount = this.orderItems[itemIndex].count;
        if (newCount === 0) {
          this.orderItems.splice(itemIndex, 1); // Remove item if count is 0
        } else {
          this.orderItems[itemIndex].count = newCount;
        }
        this.cartCount += newCount - oldCount; // Update cartCount
      }

      // Check if the orderItems array is empty and disable the submit button if it is
      const submitButton = document.querySelector('#form-order .order-submit') as HTMLButtonElement;
      if (submitButton) {
        submitButton.disabled = this.orderItems.length === 0;
      }
    },

    toggleFilterClass(event: Event) {
      const filterButtons = document.querySelectorAll('#orderItemList .button--outline-turquoise') as NodeListOf<HTMLElement>;
      if (filterButtons) {
        filterButtons.forEach((button) => {
          button.classList.remove('toggled');
        });
      }

      const eTarget = event.currentTarget as HTMLElement;
      if (eTarget) {
        eTarget.classList.toggle('toggled');
      }
    },

    toggleCart() {
      const widget = document.querySelector('.widget_dw-widget--order-service-cart') as HTMLElement;
      if (widget) {
        widget.classList.toggle('toggled');
      }
    }
  }
}

export default List;

